<!-- <style>
        .sis-reports-header-icon {
            cursor: pointer;
        }
    
    
        .folderRow {
            background-color: #cfcfcf;
        }
    
        .tableOddRow {
            /* background-color: #F0F0F0; */
            vertical-align: middle;
            width: 100%;
            height: 40px;
        }
    
        .tableOddRow:hover {
            background-color: #d7dab8;
        }
    
        .tableOddRow:focus {
            background-color: #d7dab8;
        }
    
        .tableEvenRow {
            background-color: White;
            vertical-align: middle;
            width: 100%;
            height: 40px;
        }
    
        .headerRow {
            font-weight: bold;
            display: table-header-group;
            background-color: #ffffff;
            height: 40px;
            padding-top: 5px;
            width: 100%;
        }
    
        .link {
            cursor: pointer;
            text-decoration: underline;
            /* text-wrap: none; */
            white-space: nowrap;
        }
    
        .link:hover {
            text-decoration: underline !important;
        }
    
        .sis-app-header {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            height: 65px;
            padding: 0px;
            background-color: #00366b;
            border-bottom: solid;
            border-bottom-color: #a9a9a9;
            border-bottom-width: 1px;
        }
    
        .sis-header-icon {
            display: block;
            margin-left: auto;
            margin-right: auto;
            cursor: pointer;
        }
    
        .sis-app-content {
            position: absolute;
            top: 65px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            overflow: auto;
            padding: 15px;
        }
    
        .sis-footer-customIcon {
            position: absolute;
            bottom: 2px;
            margin-right: 10px;
        }
    
        .sis-app-content-withfooter {
            position: absolute;
            top: 65px;
            left: 0px;
            right: 0px;
            bottom: 66px;
            overflow: auto;
            padding: 15px;
        }
    
        .sis-app-content-reports {
            position: absolute;
            top: 65px;
            left: 0px;
            right: 0px;
            bottom: 30px;
            overflow: auto;
            padding: 15px;
        }
    
        .sis-reports-header {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            height: 65px;
            padding: 0px;
            background-color: #2f6326;
            border-bottom: solid;
            border-bottom-color: #a9a9a9;
            border-bottom-width: 1px;
        }
    </style> -->

<!-- <div style="width:800px; height:500px;"> -->
    <!-- [ngStyle]="{'height': !loginSettings.V10 ? '95%': '100%' }" -->
    <div id="divMyReports"   style="overflow:auto; background-color: #ffffff" class="sis-app-content-withfooter">
        <h3 *ngIf="loginSettings.V10" style="display:inline; color:#3f51b5;">My Reports</h3>
        <div *ngIf="!loginSettings.V10" style="display: flex;flex-direction: row; justify-content: flex-end;">
            <h3  style="display:inline; color:#3f51b5;">My Reports</h3>
        </div>
       
        <div>
            <table *ngIf="showNoFoldersMessage">
                <tr>
                    <td colspan="4">
                        <br>
                        <br>
                        In this area you can create, view, and maintain your own set of report folders to
                        organize reports and
                        identify
                        the reports you use most often for quick access.<br>The first step is to select the Add
                        Entry icon in
                        the bottom
                        bar to create your first report folder.
                    </td>
                </tr>
            </table>
        </div>
        <!-- Angular Material table definition -->
        <div *ngIf="loginSettings.V10">
            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear>
                <!-- Individual column definitions -->
        
        
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" translate
                        class="print-ignore"></mat-header-cell>
                    <mat-cell *matCellDef="let ReportFolders"
                        style="min-width:68px;max-width:68px;text-align:center;color:black;" class="print-ignore">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="checkExpanded(ReportFolders) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
        
                <ng-container matColumnDef="ReportFolderName">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-left:5px; font-weight:bold;">
                    </mat-header-cell>
                    <mat-cell *matCellDef="let ReportFolders" style="padding-left:5px;">
                        {{ReportFolders.Name}}
                    </mat-cell>
                </ng-container>
        
                <!-- <ng-container matColumnDef="ReportName">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-left:5px; font-weight:bold; text-align:center; ">
                        <span *ngIf="allowAutoRunReport">Report</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="padding-left:5px;  text-align:center;">
                        <span *ngIf="allowAutoRunReport">{{Report.Name}} </span>
                    </mat-cell>
                </ng-container>
        
                <ng-container matColumnDef="ReportSnapshotsLength">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-left:5px; font-weight:bold; text-align:center; ">
                        <span *ngIf="allowAutoRunReport">Snapshots</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="padding-left:5px;  text-align:center;">
                        <span *ngIf="allowAutoRunReport && Report.Snapshots !== undefined">{{Report.Snapshots.length}} </span>
                    </mat-cell>
                </ng-container>
        
                <ng-container matColumnDef="AutoRun">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-left:5px; font-weight:bold; text-align:center; width:150px;">
                        <span *ngIf="allowAutoRunReport">Auto-Run</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="padding-left:5px; width:150px; text-align:center; line-height:normal;">
                        <span *ngIf="allowAutoRunReport">{{Report.Auto-Run}} </span>
                    </mat-cell>
                </ng-container>
        
                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef style="padding-bottom: 12px; padding-right:10px; text-align:right; font-weight:bold; width:50px;">Actions</mat-header-cell>
                    <mat-cell *matCellDef="let Report" style="text-align:right; width:50px; padding-right:10px;">
                        <a style="font-size:10pt;" class="link" (click)="reportSettingsClick(Report)">
                            <span>Settings</span>
                        </a>
                    </mat-cell>
                </ng-container>  -->
        
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <!-- Detail row can have standard html or another Angular Material table -->
                    <mat-cell *matCellDef="let ReportFolder" [attr.colspan]="columnsToDisplayDetailRow.length"
                        style="width:80%;" class="mat-detail-card">
                        <div style="width:80%;">
                            <table style="width:60%; " aria-label="My Reports Details Table" tabindex="-1">
                                <tr>
                                    <th class="detailLabel" style="text-align:left; width:300px;">Report</th>
                                    <th style="text-align:right; width:120px;">Snapshots</th>
                                    <th style="text-align:center; width:120px;">Auto-Run</th>
                                    <th style="text-align:center; width:120px;">Actions</th>
                                </tr>
                                <tr style="line-height:40px; border-bottom:thin solid lightgray;border-top:thin solid lightgray;"
                                    tabindex="-1" *ngFor="let Report of ReportFolder.Reports">
                                    <td class="detailLabel" style="color:#595959;width:400px;" translate>
                                        <a class="link" (click)="reportClicked(Report)">{{Report.Name}}</a>
                                    </td>
        
                                    <td class="detailLabel" style="text-align:right; width:120px" *ngIf="allowAutoRunReport">
                                        <a class="link" (click)="reportSnapshotsClick(Report, ReportFolder.Id)">
                                            <span *ngIf="Report.Snapshots != 0 && Report.Snapshots !== undefined"
                                                style="width:120px;">{{Report.Snapshots.length}}</span>
                                        </a>
                                    </td>
                                    <td class="detailLabel" style="text-align:center; width:120px" *ngIf="!allowAutoRunReport">
                                    </td>
        
                                    <td class="detailLabel" style=" text-align:center; width:120px;"
                                        *ngIf="allowAutoRunReport && Report.AllowAutoRun">{{Report.AutoRun}}</td>
                                    <td class="detailLabel" style=" text-align:center; width:120px;"
                                        *ngIf="!allowAutoRunReport || !Report.AllowAutoRun"></td>
                                    <td class="detailLabel" style="text-align:center;  width:120px;">
                                        <!-- <a style="font-size:10pt;" class="link" (click)="reportSettingsClick(Report)">
                                            <span>Settings</span> 
                                        </a>-->
                                        <!-- new menu code -->
        
                                        <div style="width:100%; text-align:center;">
                                            <img [matMenuTriggerFor]="settingsMenu" yPosition="below" alt="Actions"
                                                src="./assets/images/actions.png" style="height:30px; width:30px;" />
                                        </div>
                                        <mat-menu #settingsMenu="matMenu" [overlapTrigger]="false">
                                            <div mat-menu-item style="line-height:normal;"
                                                (click)="reportSettingsClick(Report)">
                                                <a style="font-size:10pt;cursor:pointer;">
                                                    <span>Folder Settings</span>
                                                </a>
                                            </div>
                                            <div mat-menu-item style="line-height:normal;padding-top:5px;"
                                                (click)="autorunSettingsClick(Report)">
                                                <a style="font-size:10pt;cursor:pointer;">
                                                    <span>Auto-Run Settings</span>
                                                </a>
                                            </div>
                                            <div *ngIf="useReportDefinitions" mat-menu-item
                                                style="line-height:normal;padding-top:5px;"
                                                (click)="reportOptionsClick(Report)">
                                                <a style="font-size:10pt;cursor:pointer;">
                                                    <span>Report Options</span>
                                                </a>
                                            </div>
                                        </mat-menu>
        
                                    </td>
                                </tr>
        
        
                            </table>
                        </div>
                    </mat-cell>
                </ng-container>
        
                <ng-container>
                    <!-- Row definitions determine what will actually be displayed -->
                    <!-- Styles set here will apply to all cells in the row -->
                    <!-- Header row -->
                    <mat-header-row *matHeaderRowDef="columnsToDisplay;" id="MyReportsFolders" style="min-width: 1400px;">
                    </mat-header-row>
                    <!-- Data rows -->
                    <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="MRdataRow{{i}}" tabindex="0"
                        [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                        style="font-weight: bold; padding:0px;min-width: 1400px;" matRipple (click)="toggleExpanded(row)"
                        (keydown)="rowKeyPress($event, row)">
                    </mat-row>
                    <!-- Detail row -->
                    <!-- 'overflow: hidden' is required for animation to render properly -->
                    <!-- ['expandedDetail'] -->
        
        
                    <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                        [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" class="mat-detail-row"
                        style="padding: 0.5in; min-width: 1400px; height: 100px">
        
        
        
                    </mat-row>
        
                </ng-container>
        
        
        
        
                <!-- ------------------------- -->
        
        
        
        
        
            </mat-table>
        </div>
        <div *ngIf="!loginSettings.V10">
            <div class="divTable" style="height:85%; overflow:auto;">
                <table class="table reportTable" style="margin-bottom:0px;">
                    <tbody *ngFor="let Report of Reports">
                        <tr style="background-color:#cfcfcf;" *ngIf="ReportModules.length > 0">
                            <td style="font-weight:bold;padding-left:5px;">{{Report.Description}}</td>
                        </tr>
                        <tr>
                            <td>
                                <div>
                                    <table class="table" style="margin-bottom:0px;">
                                        <tbody *ngFor="let rpt of Report.ReportsList | orderBy:'Description'">
                                            <tr>
                                                <td style="padding-left:5px;">
                                                    <a (click)="reportSettingsV9Click(rpt)">{{rpt.Description}}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    
    </div>
    <!-- OLD TABLE CODE -->
    <!--  
        <table class="table">
            <thead>
                <tr>
                    <th style="width:60px; text-align:center;" translate>&nbsp;</th>
                    <th style="padding-left:5px;">Report</th>
                    <th width="120px" style="text-align:center;" *ngIf="allowAutoRunReport">Snapshots</th>
                    <th width="120px" style="text-align:center;" *ngIf="allowAutoRunReport">Auto-Run</th>
                    <th width="120px" style="text-align:right; padding-right:20px;">Actions</th>
                </tr>
            </thead>
            <tr *ngIf="showNoFoldersMessage">
                <td colspan="4">
                    In this area you can create, view, and maintain your own set of report folders to organize reports and
                    identify
                    the reports you use most often for quick access.<br>The first step is to select the Add Entry icon in
                    the bottom
                    bar to create your first report folder.
                </td>
            </tr>
            <tbody *ngFor="let ReportFolder of ReportFolders" style="line-height:25px;" class="folderRow">
                <tr style="line-height:25px;">-->
    <!-- Expand/Collapse box-->
    <!-- <td style="cursor:pointer; text-align:center;" (click)="expandCollapseFolder(ReportFolder)">
                        <span id="span{{ReportFolder.Id}}" [ngClass]="{'tyl-ico-minus' : ReportFolder.IsDetailRowExpanded, 'tyl-ico-plus' : !ReportFolder.IsDetailRowExpanded}"></span> -->
    <!-- <span id="span{{ReportFolder.Id}}" [ngClass]="{'tyl-ico-minus' : expandedRows[ReportFolder.Id], 'tyl-ico-plus' : !expandedRows[ReportFolder.Id]}"></span>  -->
    <!-- </td>
                    <td style="padding-left:5px; font-weight:bold;">{{ReportFolder.Name}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr *ngIf="ReportFolder.IsDetailRowExpanded">
                    <td colspan="5" style="padding-left:5px;">
                        <table style="width:99%;">
                            <tbody *ngFor="let Report of ReportFolder.Reports" [ngClass]="{'tableOddRow': !isEven($index +1), 'tableEvenRow': isEven($index +1)}"
                                st-select-row="Report" st-select-mode="single" style="line-height:40px;">
                                <tr style="line-height:40px;">
                                    <td width="60px">&nbsp;</td>
                                    <td style="padding-left:5px;">
                                        <a class="link" (click)="reportClicked(Report)">{{Report.Name}}</a>
                                    </td>
                                    <td style="padding-left:5px; text-align:center; width:120px" *ngIf="allowAutoRunReport">
                                        <a class="link" (click)="reportSnapshotsClick(Report, ReportFolder.Id)">
                                            <div *ngIf="Report.Snapshots != 0" style="width:100%;">{{Report.Snapshots.length}}</div>
                                        </a>
                                    </td>
                                    <td style="padding-left:5px; text-align:center; width:120px;" *ngIf="allowAutoRunReport">{{Report.AutoRun}}</td>
                                    <td style="text-align:right; text-align:right; width:120px; padding-right:10px;">
                                        <a style="font-size:10pt;" class="link" (click)="reportSettingsClick(Report)">
                                            <span>Settings</span>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr style="line-height:10px; background-color:#cfcfcf;">
                                    <td colspan="5">&nbsp;</td>
                                </tr>
                            </tbody>
                        </table> 
                    </td>
                </tr>
            </tbody>
        </table>-->
    
    
    <!-- </mat-dialog-content> -->